import { ExtDate } from '@/helpers/date';

export default {
  params: ['minAge'],
  validate: (birthday, { minAge }) => {
    return {
      valid: new ExtDate().differenceInYears(birthday) >= minAge,
    };
  },
};
